import React from 'react';
import QRGenerator from './QRGenerator';

export default function LinkQR() {
  return (
    <div className="flex flex-col gap-12 w-full max-w-4xl mx-auto">
      <section className="text-center max-w-2xl mx-auto flex flex-col gap-4 py-4">
        <span className="self-center px-3 py-1 rounded-full bg-indigo-600/10 text-indigo-400 border border-indigo-500/20 text-xs font-semibold uppercase tracking-wider">
          Link to QR Generator
        </span>
        <h1 className="text-4xl md:text-5xl font-black tracking-tight leading-tight bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-400 bg-clip-text text-transparent">
          Free Link to QR Code Maker
        </h1>
        <p className="text-gray-400 text-sm md:text-base leading-relaxed">
          Instantly convert any website URL, social link, online document, or landing page into a custom high-resolution QR code. Client-side compiled, 100% private, and completely free.
        </p>
      </section>

      <section className="w-full">
        <QRGenerator defaultTab="url" hideTabs={true} />
      </section>

      <section className="border-t border-gray-900 pt-10 flex flex-col gap-4 text-sm text-gray-400 leading-relaxed max-w-3xl mx-auto">
        <h2 className="text-lg font-bold text-gray-200">How to use the Free Link to QR Maker</h2>
        <p>
          Converting website links into QR codes is extremely straightforward. Simply type or paste your complete destination link (including the <code>https://</code> header) into the input box above. The preview box will immediately redraw your custom vector block in real-time. 
        </p>
        <p>
          You can utilize our design presets to instantly apply gorgeous styling colors, adjust dot styles to smooth rounded circles, upload your business logo, and download the final high-resolution file in PNG or vector SVG format. No email logins or credit card registrations are ever required.
        </p>
      </section>
    </div>
  );
}
